module.exports = __webpack_public_path__ + "static/f2-78987e0f3c44cd2084db3c8f6246bd4e.png";